import * as Types from '../generated/webapp_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DepartmentsSentSurveysQueryVariables = Types.Exact<{
  employeeId: Types.Scalars['Int']['input'];
  sort?: Types.InputMaybe<Types.SortByCreatedAtInput>;
}>;


export type DepartmentsSentSurveysQuery = { __typename?: 'Query', employee?: { __typename?: 'Employee', id: number, departmentsSentSurveys?: { __typename?: 'SurveyTemplateCollection', total?: number | null, items?: Array<{ __typename?: 'SurveyTemplate', id: string, title: string, latestSendDate?: any | null } | null> | null } | null } | null };


export const DepartmentsSentSurveysDocument = gql`
    query DepartmentsSentSurveys($employeeId: Int!, $sort: SortByCreatedAtInput) {
  employee(id: $employeeId) {
    id
    departmentsSentSurveys(sort: $sort) {
      items {
        id
        title
        latestSendDate
      }
      total
    }
  }
}
    `;

/**
 * __useDepartmentsSentSurveysQuery__
 *
 * To run a query within a React component, call `useDepartmentsSentSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartmentsSentSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartmentsSentSurveysQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useDepartmentsSentSurveysQuery(baseOptions: Apollo.QueryHookOptions<DepartmentsSentSurveysQuery, DepartmentsSentSurveysQueryVariables> & ({ variables: DepartmentsSentSurveysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DepartmentsSentSurveysQuery, DepartmentsSentSurveysQueryVariables>(DepartmentsSentSurveysDocument, options);
      }
export function useDepartmentsSentSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DepartmentsSentSurveysQuery, DepartmentsSentSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DepartmentsSentSurveysQuery, DepartmentsSentSurveysQueryVariables>(DepartmentsSentSurveysDocument, options);
        }
export function useDepartmentsSentSurveysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DepartmentsSentSurveysQuery, DepartmentsSentSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DepartmentsSentSurveysQuery, DepartmentsSentSurveysQueryVariables>(DepartmentsSentSurveysDocument, options);
        }
export type DepartmentsSentSurveysQueryHookResult = ReturnType<typeof useDepartmentsSentSurveysQuery>;
export type DepartmentsSentSurveysLazyQueryHookResult = ReturnType<typeof useDepartmentsSentSurveysLazyQuery>;
export type DepartmentsSentSurveysSuspenseQueryHookResult = ReturnType<typeof useDepartmentsSentSurveysSuspenseQuery>;
export type DepartmentsSentSurveysQueryResult = Apollo.QueryResult<DepartmentsSentSurveysQuery, DepartmentsSentSurveysQueryVariables>;